import { Checkbox, Form } from 'antd';
import Button from 'components/Button';
import DrawerComponent from 'components/Drawer';
import SelectComponent from 'components/Select';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMutateAssignAWDAg from 'screens/farmer-groups/hooks/useMutateAssignAWDAg';
import useUserByRoleCountryQuery from 'screens/farmer-groups/hooks/useUserByRoleCountryQuery';
import { FarmerGroupV2 } from 'types/response';

type AssignAWDAgProps = {
  data?: FarmerGroupV2;
  open: boolean;
  country?: string;
  onClose: () => void;
  onSuccess: () => void;
};
const AssignAWDAg = ({
  data,
  open,
  country = 'Indonesia',
  onClose,
  onSuccess,
}: AssignAWDAgProps) => {
  const [email, setEmail] = useState<string>();
  const [checked, setChecked] = useState(false);

  const { t } = useTranslation();

  const { filterOptions, isLoading: isAgronomistLoading } =
    useUserByRoleCountryQuery({
      country: [country],
      role: ['Agronomist - AWD'],
    });

  const onCloseDrawer = () => {
    setEmail('');
    setChecked(false);
    onClose();
  };

  const { mutate, isPending: isLoading } = useMutateAssignAWDAg({
    onSuccess,
    onFinish: onCloseDrawer,
  });

  const onFinish = async () => {
    if (!data?.id) return;
    mutate({
      cubeId: data.id,
      almAgronomistEmail: email as string,
    });
  };

  useEffect(() => {
    setEmail(data?.almCoordinator?.email);
  }, [data]);

  return (
    <DrawerComponent
      title={t('farmerGroups.reassignAWDAg')}
      open={open}
      onClose={onCloseDrawer}
      loading={isLoading}
      content={
        <>
          <Form.Item
            className="reassign-ag-input"
            label={t('common.filters.awdAgronomistPlaceholder')}
            required
            labelCol={{ span: 24 }}
            rules={[{ required: true }]}
          >
            <SelectComponent
              value={email}
              onChange={setEmail}
              placeholder={t('addFgForm.selectEmail')}
              showSearch
              options={filterOptions}
              loading={isAgronomistLoading}
            />
          </Form.Item>
          <Checkbox
            className="farmer-group-checkbox"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          >
            {t('farmerGroups.assignAWDAgCheckboxDescription')}
          </Checkbox>
          <Button
            type="primary"
            disabled={
              !email ||
              email === data?.rizeusersByFieldCoordinator?.name ||
              !checked
            }
            style={{ width: '100%', marginTop: '24px' }}
            onClick={onFinish}
            loading={isLoading}
          >
            {t('farmerGroups.assignAWDAg')}
          </Button>
        </>
      }
    />
  );
};

export default AssignAWDAg;
